const CRC32C_POLYNOMIAL = 0x82f63b78;
const CHECKSUM_CHUNK_BYTES = 4 * 1024 * 1024;

function createCrc32cTable(): Uint32Array {
  const table = new Uint32Array(256);
  for (let index = 0; index < table.length; index += 1) {
    let value = index;
    for (let bit = 0; bit < 8; bit += 1) {
      value =
        (value & 1) === 1 ? (value >>> 1) ^ CRC32C_POLYNOMIAL : value >>> 1;
    }
    table[index] = value >>> 0;
  }
  return table;
}

const CRC32C_TABLE = createCrc32cTable();

function readBlob(blob: Blob): Promise<ArrayBuffer> {
  if (typeof blob.arrayBuffer === "function") {
    return blob.arrayBuffer();
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error ?? new Error("Read failed"));
    reader.onload = () => {
      if (reader.result instanceof ArrayBuffer) {
        resolve(reader.result);
        return;
      }
      reject(new Error("Unexpected file reader result"));
    };
    reader.readAsArrayBuffer(blob);
  });
}

function encodeUint32(value: number): string {
  const bytes = String.fromCharCode(
    (value >>> 24) & 0xff,
    (value >>> 16) & 0xff,
    (value >>> 8) & 0xff,
    value & 0xff,
  );
  return btoa(bytes);
}

export async function crc32cFile(file: Blob): Promise<string> {
  let checksum = 0xffffffff;
  for (let offset = 0; offset < file.size; offset += CHECKSUM_CHUNK_BYTES) {
    const end = Math.min(offset + CHECKSUM_CHUNK_BYTES, file.size);
    const bytes = new Uint8Array(await readBlob(file.slice(offset, end)));
    for (const byte of bytes) {
      const tableIndex = (checksum ^ byte) & 0xff;
      checksum = (checksum >>> 8) ^ (CRC32C_TABLE[tableIndex] ?? 0);
    }
  }
  return encodeUint32((checksum ^ 0xffffffff) >>> 0);
}
